import { render, staticRenderFns } from "./PlayerIndividualSeasons.vue?vue&type=template&id=2d487d20&"
import script from "./PlayerIndividualSeasons.vue?vue&type=script&lang=js&"
export * from "./PlayerIndividualSeasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports